<div class="card mt-4">
  <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbSociete"></p-breadcrumb>
</div>
<div class="card mt-4">


  <div class="font-semibold text-xl mb-4">Liste des Sociétés - {{this.nomDo}} - {{this.DO}}</div>
  <p-toolbar styleClass="mb-6">
    <ng-template #start>
      <p-button label="Ajouter" icon="pi pi-plus" severity="primary" class="mr-2" (onClick)="openNew()" />

      <p-button severity="secondary" label="Désactiver" icon="pi pi-times" outlined class="mr-2"
        [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedSocietes || !selectedSocietes.length || allSelectedSocietesInactive() || hasMixedSelection()"
        (onClick)="disableSelectedSocietes()" />
      <p-button severity="secondary" label="Activer" icon="pi pi-check" outlined class="mr-2"
        [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedSocietes || !selectedSocietes.length || allSelectedSocietesActive() || hasMixedSelection()"
        (onClick)="enableSelectedSocietes()" />
    </ng-template>

    <ng-template #end>
            <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary" class="mr-2"
                (click)="openUploadDialog()" />
            <p-dialog header="Importation en masse" [(visible)]="UploadDialog" [breakpoints]="{ '960px': '75vw' }"
                [style]="{ width: '30vw' }" [modal]="true">

                <div class="flex flex-col items-center text-center p-4 w-full">

                    <!-- Bouton Export -->
                    <p-button label="Exporter le modèle" icon="pi pi-download" severity="secondary" class="mb-4"
                        (onClick)="telechargerTemplateCSV()">
                    </p-button>

                    <!-- Upload -->
                    <p-fileupload #uploader name="demo[]" [multiple]="true" [accept]="'.csv'" [auto]="false"
                        [customUpload]="true" (uploadHandler)="onUpload($event, uploader)" [maxFileSize]="500000"
                        mode="advanced" uploadLabel="Importer" class="w-full">

                        <!-- Texte d'info quand vide -->
                        <ng-template #empty>
                            <div class="text-sm text-gray-500">
                                Faites glisser et déposez le fichier CSV ici pour l'importer.
                            </div>
                        </ng-template>

                        <!-- Liste des fichiers sélectionnés -->
                        <ng-template #content>
                            <ul *ngIf="uploadedFiles.length" class="mt-2 text-sm">
                                <li *ngFor="let file of uploadedFiles">{{ file.name }} - {{ file.size }} bytes</li>
                            </ul>
                        </ng-template>
                    </p-fileupload>

                    <!-- Radio buttons -->
                    <div class="mt-4">
                        <label class="block font-semibold text-sm mb-2">Voulez-vous écraser les données existantes
                            ?</label>
                        <div class="flex justify-center gap-6">
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="true" [(ngModel)]="add_on"
                                    inputId="noEcrase" />
                                <label for="noEcrase" class="text-sm">Non</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="false" [(ngModel)]="add_on"
                                    inputId="yesEcrase" />
                                <label for="yesEcrase" class="text-sm">Oui</label>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <ng-template #footer>
                    <p-button label="Fermer" icon="pi pi-times" (click)="closeUploadDialog()" class="p-button-text" />
                </ng-template>
            </p-dialog>
            <!-- <p-button label="Exporter en CSV" icon="pi pi-download" severity="secondary"

                [disabled]="loading || !societes || societes.length === 0"></p-button> -->
        </ng-template>
  </p-toolbar>
  <p-table #dt1 [value]="societes" dataKey="code_interne" [rows]="10" [rowHover]="true" [showGridlines]="true"
    [paginator]="true" [tableStyle]="{ 'min-width': '75rem' }" [(selection)]="selectedSocietes"
    currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} societes" [loading]="loading"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions" [globalFilterFields]="[
            'code_interne',
            'Nom',
  'Site',
  'Ville',
  'Tel1',
  'AdrEmail','FlagActif','AgentModif','Departement','NumContrat'

]" responsiveLayout="scroll">
    <ng-template #caption>
      <div class="flex justify-between items-center flex-column sm:flex-row">
        <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
          (click)="clear(dt1)"></button>
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher" />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th style="width: 2rem; font-weight: bold !important; text-align: center; vertical-align: middle;">
          <p-tableHeaderCheckbox />
        </th>

        <th
          style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Code Société</span>
            <p-columnFilter type="text" field="code_interne" display="menu" placeholder="Rechercher par code" />
          </div>
        </th>

        <th
          style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Nom</span>
            <p-columnFilter type="text" field="Nom" display="menu" placeholder="Rechercher par Nom" />
          </div>
        </th>

        <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Site</span>
            <p-columnFilter type="text" field="Site" display="menu" placeholder="Rechercher par Site" />
          </div>
        </th>



        <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Téléphone</span>
            <p-columnFilter type="text" field="Tel1" display="menu" placeholder="Rechercher par Téléphone" />
          </div>
        </th>

        <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Email</span>
            <p-columnFilter type="text" field="AdrEmail" display="menu" placeholder="Rechercher par Email" />
          </div>
        </th>
        <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-between items-center">
            <span style="font-weight: bold;">Dernier Modificateur</span>
            <p-columnFilter type="text" field="AgentModif" display="menu" placeholder="Rechercher par Dernier Modificateur" />
          </div>
        </th>
        <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-center items-center">
            <span style="font-weight: bold;">Statut</span>
            <p-columnFilter field="FlagActif" matchMode="equals" display="menu">
              <ng-template #filter let-value let-filter="filterCallback">
                <p-select [ngModel]="value" [options]="statusOptions" (onChange)="filter($event.value)"
                  placeholder="Rechercher par Statut" [style]="{ 'min-width': '12rem' }">
                  <ng-template let-option #item>
                    <span [class]="'customer-badge status-' + option.value">{{ option.label }}</span>
                  </ng-template>
                </p-select>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
          <div class="flex justify-center items-center">
            <span style="font-weight: bold;">Actions</span>
          </div>
        </th>
      </tr>

    </ng-template>

    <ng-template #body let-societe>
      <tr>
        <td style="text-align: center; vertical-align: middle;">
          <p-tableCheckbox [value]="societe" />
        </td>

        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.code_interne }}</td>
        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.Nom }}</td>
        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.Site }}</td>
        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.Tel1 }}</td>
        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.AdrEmail }}</td>
        <td style="padding: 0.5rem; white-space: nowrap;">{{ societe.AgentModif}}</td>
        <td>
          <div class="flex justify-center items-center gap-2">
            <p-toggleSwitch [(ngModel)]="societe.FlagActif" [trueValue]="1" [falseValue]="0"
              [disabled]="societe.toggleLoading" (onChange)="onToggleChange(societe)" class="scale-90">
              <ng-template #handle let-checked="checked">
                <i [ngClass]="{'!text-xs pi': true, 'pi-check': checked, 'pi-times': false}"></i>
              </ng-template>
            </p-toggleSwitch>
            <span class="font-semibold w-20"> {{ societe.FlagActif === 1 ? 'Activé' : 'Désactivé' }}</span>
          </div>
        </td>

        <td class="text-center" style="padding: 0.5rem; vertical-align: middle;">
          <div class="flex justify-center items-center gap-2">
            <p-button icon="pi pi-eye" (onClick)="openDetailsSociete(societe)" class="mr-1" [rounded]="true"
              [outlined]="true" />
            <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true" (click)="editSociete(societe)"></p-button>
            <!-- <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
              (click)="deleteByOne(societe)"></p-button> -->
          </div>
        </td>
      </tr>

    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="8">Pas de société.</td>
      </tr>
    </ng-template>
    <ng-template #loadingbody>
      <tr>
        <td colspan="8">Chargement des données sociétés. Veuillez patienter.</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [(visible)]="ajoutDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Ajouter Société"
    [modal]="true">
    <ng-template #content>
      <div class="flex flex-col gap-6">

        <!-- Bloc 1 : Informations de base -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Code DO</label>
            <input type="text" pInputText [(ngModel)]="DO" disabled class="w-full" />
          </div>
          <div>
          <label class="block font-bold mb-2">Identifiant Client</label>
          <input type="text" pInputText [(ngModel)]="societe.Identifiant" class="w-full" />
        </div>

        </div>

        <!-- Bloc 2 : Coordonnées société -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Nom <span class="text-red-500">*</span></label>
            <input type="text" pInputText [(ngModel)]="societe.Nom" class="w-full" />
            <small *ngIf="nomAjoutInvalide" class="text-red-500">Le nom est requis</small>
          </div>
          <div>
            <label class="block font-bold mb-2">Site</label>
            <input type="text" pInputText [(ngModel)]="societe.Site" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Adresse 1</label>
            <input type="text" pInputText [(ngModel)]="societe.Adresse1" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Adresse 2</label>
            <input type="text" pInputText [(ngModel)]="societe.Adresse2" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Code Postal</label>
            <input type="text" pInputText [(ngModel)]="societe.CodePostal" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Ville</label>
            <input type="text" pInputText [(ngModel)]="societe.Ville" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Téléphone</label>
            <input type="text" pInputText [(ngModel)]="societe.Tel1" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Email</label>
            <input type="text" pInputText [(ngModel)]="societe.AdrEmail" class="w-full" />
            <small *ngIf="emailAjoutInvalide" class="text-red-500">Format d'email invalide</small>
          </div>
        </div>

        <!-- Bloc 3 : Contrat & Machine -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label class="block font-bold mb-2">Num Contrat</label>
            <input type="text" pInputText [(ngModel)]="societe.NumContrat" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Client</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeClient" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Num Série</label>
            <input type="text" pInputText [(ngModel)]="societe.NumSerie" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Machine</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeMachine" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Contrat</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeContrat" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Code Couverture</label>
            <input type="text" pInputText [(ngModel)]="societe.code_Couverture" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Zone</label>
            <input type="text" pInputText [(ngModel)]="societe.Zone" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Interne</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeInterne" class="w-full" />
          </div>
        </div>

        <!-- Bloc 4 : Remarques -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Info complémentaire</label>
            <input pInputText [(ngModel)]="societe.Info1" rows="3" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Département</label>
            <input pInputText [(ngModel)]="societe.Departement" rows="3" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Siret</label>
            <input pInputText [(ngModel)]="societe.Siret" rows="3" class="w-full" />
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #footer>
      <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
      <p-button label="Enregistrer" [disabled]="buttonDisable" icon="pi pi-check" (click)="ajouterSociete(societe)" />
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="updateDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Modifier Société"
    [modal]="true">
    <ng-template #content>
      <div class="flex flex-col gap-6">

        <!-- Bloc 1 : Informations de base -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Code DO</label>
            <input type="text" pInputText [(ngModel)]="DO" disabled class="w-full" />
          </div>
           <div>
          <label class="block font-bold mb-2">Code Société</label>
          <input type="text" pInputText [(ngModel)]="societe.code_interne" disabled class="w-full" />
        </div>
        <div>
          <label class="block font-bold mb-2">Identifiant Client</label>
          <input type="text" pInputText [(ngModel)]="societe.Identifiant" class="w-full" />
        </div>

        </div>

        <!-- Bloc 2 : Coordonnées société -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Nom<span class="text-red-500">*</span></label>
            <input type="text" pInputText [(ngModel)]="societe.Nom" class="w-full" />
            <small *ngIf="nomUpdateInvalide" class="text-red-500">Le nom est requis</small>
          </div>
          <div>
            <label class="block font-bold mb-2">Site</label>
            <input type="text" pInputText [(ngModel)]="societe.Site" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Adresse 1</label>
            <input type="text" pInputText [(ngModel)]="societe.Adresse1" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Adresse 2</label>
            <input type="text" pInputText [(ngModel)]="societe.Adresse2" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Code Postal</label>
            <input type="text" pInputText [(ngModel)]="societe.CodePostal" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Ville</label>
            <input type="text" pInputText [(ngModel)]="societe.Ville" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Téléphone</label>
            <input type="text" pInputText [(ngModel)]="societe.Tel1" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Email</label>
            <input type="text" pInputText [(ngModel)]="societe.AdrEmail" class="w-full" />
            <small *ngIf="emailUpdateInvalide" class="text-red-500">Format d'email invalide</small>
          </div>
        </div>

        <!-- Bloc 3 : Contrat & Machine -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label class="block font-bold mb-2">Num Contrat</label>
            <input type="text" pInputText [(ngModel)]="societe.NumContrat" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Client</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeClient" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Num Série</label>
            <input type="text" pInputText [(ngModel)]="societe.NumSerie" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Machine</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeMachine" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Contrat</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeContrat" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Code Couverture</label>
            <input type="text" pInputText [(ngModel)]="societe.code_Couverture" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Zone</label>
            <input type="text" pInputText [(ngModel)]="societe.Zone" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Type Interne</label>
            <input type="text" pInputText [(ngModel)]="societe.TypeInterne" class="w-full" />
          </div>
        </div>

        <!-- Bloc 4 : Remarques -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block font-bold mb-2">Info complémentaire</label>
            <input pInputText [(ngModel)]="societe.Info1" rows="3" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Département</label>
            <input pInputText [(ngModel)]="societe.Departement" rows="3" class="w-full" />
          </div>
          <div>
            <label class="block font-bold mb-2">Siret</label>
            <input pInputText [(ngModel)]="societe.Siret" rows="3" class="w-full" />
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #footer>
      <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
      <p-button label="Enregistrer" [disabled]="buttonDisable" icon="pi pi-save" (click)="UpdateSociete(societe.code_interne,societe)" />
    </ng-template>
  </p-dialog>


  <p-dialog [(visible)]="detailsSocieteDialog" [style]="{ width: '100%', maxWidth: '1000px' }"
    header="Détails du Société" [modal]="true" [draggable]="false" [resizable]="false">
  <ng-template #content>
    <div class="flex flex-col gap-6">

      <!-- Bloc 1 : Informations de base -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4" *ngIf="selectedSocieteItem">
        <div>
          <label class="block font-bold mb-2">Code DO</label>
          <input type="text" pInputText [value]="DO" disabled class="w-full" />
        </div>
          <div>
          <label class="block font-bold mb-2">Code Société</label>
          <input type="text" pInputText [value]="selectedSocieteItem.code_interne" disabled class="w-full" />
        </div>
        <div>
          <label class="block font-bold mb-2">Identifiant Client</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Identifiant" disabled class="w-full" />
        </div>
      </div>

      <!-- Bloc 2 : Coordonnées société -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Nom</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Nom" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Site</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Site" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Adresse 1</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Adresse1" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Adresse 2</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Adresse2" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Code Postal</label>
          <input type="text" pInputText [value]="selectedSocieteItem.CodePostal" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Ville</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Ville" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Téléphone</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Tel1" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Email</label>
          <input type="text" pInputText [value]="selectedSocieteItem.AdrEmail" class="w-full" [readOnly]="true" />
        </div>
      </div>

      <!-- Bloc 3 : Contrat & Machine -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <label class="block font-bold mb-2">Num Contrat</label>
          <input type="text" pInputText [value]="selectedSocieteItem.NumContrat" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Type Client</label>
          <input type="text" pInputText [value]="selectedSocieteItem.TypeClient" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Num Série</label>
          <input type="text" pInputText [value]="selectedSocieteItem.NumSerie" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Type Machine</label>
          <input type="text" pInputText [value]="selectedSocieteItem.TypeMachine" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Type Contrat</label>
          <input type="text" pInputText [value]="selectedSocieteItem.TypeContrat" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Code Couverture</label>
          <input type="text" pInputText [value]="selectedSocieteItem.code_Couverture" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Zone</label>
          <input type="text" pInputText [value]="selectedSocieteItem.Zone" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Type Interne</label>
          <input type="text" pInputText [value]="selectedSocieteItem.TypeInterne" class="w-full" [readOnly]="true" />
        </div>
      </div>

      <!-- Bloc 4 : Remarques -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <label class="block font-bold mb-2">Info complémentaire</label>
          <input pInputText [value]="selectedSocieteItem.Info1" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Département</label>
          <input pInputText [value]="selectedSocieteItem.Departement" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Siret</label>
          <input pInputText [value]="selectedSocieteItem.Siret" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Dernier Modificateur</label>
          <input pInputText [value]="selectedSocieteItem.AgentModif" class="w-full" [readOnly]="true" />
        </div>
        <div>
          <label class="block font-bold mb-2">Date Dern Modif</label>
         <input pInputText
       [value]="selectedSocieteItem.DateModif | date:'dd/MM/yyyy HH:mm a'"
       class="w-full"
       [readOnly]="true" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #footer>
    <p-button label="Fermer" icon="pi pi-times" text (click)="hideDialog()" />
  </ng-template>
</p-dialog>

  <p-confirmdialog [style]="{ width: '450px' }" />


  <p-confirmdialog [style]="{ width: '450px' }" />




</div>
<p-toast />
